module.exports = __webpack_public_path__ + "static/media/platform_mannual_en.959736ab.md";